import { Injectable } from '@angular/core';
import { DomainsModel } from 'src/app/models/domains.model';
import { DomainService } from 'src/app/services/domain/domain.service';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { environment } from 'src/environments/environment';
import { LoterriesService } from '../lotteries/loterries.service';

const domainRestriction: any = environment.domainRestriction;

@Injectable({
  providedIn: 'root'
})
export class RestrictionService {
  private currentDomain: DomainsModel;

  constructor(
    private _domain: DomainService, 
    private _window: WindorefService
  ) {}

  setRestrictions(): void {
    this.currentDomain = this._domain.getCurrentDomain();
    if (domainRestriction != null) {
      let domainFound = domainRestriction.find((domain) => domain == this.currentDomain.domain);
      if (this.currentDomain.domain != domainFound) {
        let redirectToDomain = this._mostAccurateDomain().domain;
        let pathAndParams = this._pathAndParams();
        this._window.getNativeWindow().location.href = `https://${redirectToDomain}${pathAndParams}`;
      }
    }
  }

  private _mostAccurateDomain(): DomainsModel {
    return this._domain.getCurrentDomain(domainRestriction[0]);
  }
  private _pathAndParams(): any {
    let location = this._window.getNativeWindow().location;
    return `${location.pathname}${location.search}`;
  }
}
